import { render, staticRenderFns } from "./doubao.vue?vue&type=template&id=7725edc4&scoped=true"
import script from "./doubao.vue?vue&type=script&lang=js"
export * from "./doubao.vue?vue&type=script&lang=js"
import style0 from "./doubao.vue?vue&type=style&index=0&id=7725edc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7725edc4",
  null
  
)

export default component.exports